module.exports = __webpack_public_path__ + "static/img/tu13.bf05caa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tu13.png
// module id = qUyV
// module chunks = 128